<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<div class="title">
			<div id="notice">
				<h5>运输费用合计&nbsp;&nbsp;说明:</h5><br>

				<span>2、查询关键字:订单号、调度单号、业务单号、厂家、车牌、起点、终点、付款日期、付款金额、收款人</span><br>
				<span></span><br>
			</div>
		</div>
		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>

		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->
				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>

			</div>
		</div>

		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>

				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'m_' + user.item[1].val" @click="sel_row(user.item,'edit')"
					@dblclick="sel_row(user.item,'show')">

					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						{{d.val}}
					</td>
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>

		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<pretan ref="mypop">
			<template slot="tancontent">
				<!-- <h3 class="cen">{{title}}</h3> -->
				<!-- 操作按钮生成 -->

				<div class="tab-detail">
					<h5 class="cen pretop">费用明细</h5>
				</div>


				<!-- 这里放明细单据内容 -->
				<!-- 明细部分编辑区 -->
				<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
					<tr class="tab_header_new">
						<td>序号</td>
						<td>名称</td>
						<td>申请金额</td>
						<td>录入支付日期</td>
						<td>申请备注</td>
						<td>审核金额</td>
						<td>审核备注</td>
						<td>卡号</td>
						<td>打款日期</td>
						<td>开票</td>
						<td>公司已支付</td>
						<!-- <td class="short0 cen">操作</td> -->
					</tr>
					<tr :id="'d_'+data_tr.row_num" v-for="data_tr in list_detail">
						<!-- <td>{{data_tr.id}}</td> -->
						<td>{{data_tr.row_num}}</td>
						<!-- <td>{{data_tr.sheet_no}}</td> -->
						<td>{{data_tr.pay_name}}</td>
						<td>{{data_tr.apply_amount}}</td>
						<td>{{data_tr.apply_date}}</td>
						<td v-on:mousemove="show_detaildata($event, data_tr.note, '1')"
							v-on:mouseout="noshow_detaildata">{{data_tr.note}}</td>
						<td>{{data_tr.ok_amount}}</td>
						<td v-on:mousemove="show_detaildata($event, data_tr.note, '1')"
							v-on:mouseout="noshow_detaildata">{{data_tr.ok_note}}</td>
						<td>{{data_tr.f_no}}</td>
						<td>{{data_tr.p_date}}</td>
						<td>{{data_tr.is_paper}}</td>
						<td>{{data_tr.is_pay}}</td>
						<!-- <td class="short0 cen">
					      <button @click="fun_d_upd('_del',data_tr)">删除</button>
					    </td> -->
					</tr>
				</table>





			</template>
		</pretan>


		<!-- 文件预览部分 -->
		<!-- 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefile" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="savefile" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Select_PageLengthMore,
		Method_CommonLong
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';


	export default {
		components: {
			"pre-button": () => import("../per_old/pre_btn_control.vue"),
			'per-exceldown': () => import("../auto/auto_excel_down.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue")
		},
		data() {
			return {
				element_loading: false,

				row_id: '',
				sys_date: '',

				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				sheet_flag: '',

				// excel
				show_excel: false,
				postjson1: {},

				// 备注
				detail_data: '',
				max_row: [],

				sel_action: '',

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',

				//文件
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				list_file: [],
				list_detail: [],
				sheet_no: ''


			};
		},
		activated() {
			console.log('激活');
		},
		mounted() {
			console.log('加载');
			this.load_data();
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d, type) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}

				if (type == 'save') {
					this.load_db_data();
				}
			},
			check_is_pdf: function(res_url) {
				let is_pdf = false;
				if (/\.(pdf)$/.test(res_url.toLowerCase())) {
					is_pdf = true;
				}
				return is_pdf;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {
				// console.log(r);
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.control = 'io_detail_ys';
				this.sel_action = 'exp_cw_tabiodetail_ys';
				this.upd_action = '';
				this.api_url = api.http_method;

				this.title = '运输收支流水';
				// 订单号、调度单号、业务单号、厂家、车牌、起点、终点、付款日期、付款金额、收款人
				this.parm_sel = [{
						"name": "订单编号",
						"val": "",
						"key": "order_no",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "调度单号",
						"val": "",
						"key": "sheet_ys",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "业务单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "厂家",
						"val": "",
						"key": "c_name",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "车牌",
						"val": "",
						"key": "car_no",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "起点",
						"val": "",
						"key": "s_date",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "终点",
						"val": "",
						"key": "e_date",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "付款日期",
						"val": "",
						"key": "pay_date",
						"type": "date",
						"class": "long1"
					},
					{
						"name": "付款金额",
						"val": "",
						"key": "pay_number",
						"type": "number",
						"class": "long1"
					},
					{
						"name": "收款人",
						"val": "",
						"key": "rec_user",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "费用分类",
						"val": "",
						"key": "pay_all",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_pay_all",
						"sel_name": "",
						"sel": "8"
					}
				]
				// sheet_no,sign_no,u_name,sex,u_phone,u_email,u_old,u_address,u_qq,
				//u_weixin,u_stu,u_College,profession,u_grade,note from tb_user_sign_up_all
				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "订单单号"
					},
					{
						"name": "调度单号"
					},
					{
						"name": "业务单号"
					},
					{
						"name": "厂家"
					},
					{
						"name": "起点"
					},
					{
						"name": "终点"
					},
					{
						"name": "货名"
					},
					{
						"name": "申请人",
						"class": "short0"
					},
					{
						"name": "收入金额"
					},
					{
						"name": "收入审批"
					},
					{
						"name": "支出金额"
					},
					{
						"name": "支出审批"
					},
					{
						"name": "收款人"
					},
					{
						"name": "收款人账号"
					},

					{
						"name": "打款方式"
					},
					{
						"name": "打款日期"
					},

					{
						"name": "打款备注"
					},
					{
						"name": "打款人"
					},
					// {
					// 	"name": "附件1"
					// },
					// {
					// 	"name": "附件2"
					// },
					{
						"name": "更新时间",
						"class": "long2"
					}
				]


				this.parm = []


				this.load_db_data();

			},
			select_method: function(type) {
				console.log(type);

				switch (type) {
					case 'sel':
						this.load_db_data();
						break;
					case 'new':
						for (let i = 0; i < this.parm_sel.length; i++) {
							this.parm_sel[i].val = '';
						}
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filelook':
						this.fun_filelook();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				console.log(this.parm_sel);
				let d = [];
				for (let i = 0; i < this.parm_sel.length; i++) {
					d.push(this.parm_sel[i].val)
				}
				console.log(d);

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Select_PageLengthMore(that.sel_action, that.nowpage, that.page_length, d,
						'tab', r);
				}, 200);
			},
			hide_edit_view: function() {
				this.$refs.file_table.hide();
			},
			refresh_data: function(type, page, pagelength, backdata) {
				console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				if (type == 'PAGE_LENGTH_CHANGE') {
					this.page_length = pagelength;
					this.nowpage = page;
					this.load_db_data();
					return;
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				if (type == 'UPDATE_OK') {
					let back = null;
					if (typeof(backdata) != "undefined" && backdata != '') {
						back = JSON.parse(backdata);
						console.log(back);
						// console.log('new_id=' + back.new_id);
						this.row_id = back.new_id;
						this.sheet_flag = back.msg;
						// 同步关键参数便于后续修改
						this.sys_date = back.sys_date;
						this.sheet_no = back.sheet_no;
						for (let i = 0; i < this.parm.length; i++) {
							if (this.parm[i].key == 'sheet_no') {
								this.parm[i].val = this.sheet_no;
								break;
							}
						}

						this.element_loading = true;
						let r = (Math.random() + '').substring(0, 8);
						let d = [];
						d.push('ID' + this.row_id);

						this.$post(
							api.http_method, Select_PageLengthMore(this.sel_action, 1, 1, d, tab, r)
						).then(res => {
							res = JSON.parse(res);

							this.element_loading = false;
							let res_page = [];
							res_page = res[0][0];

							if (res_page.flag == 1) {
								let bd = [];
								// console.log('allcount='+res_page.all_count)
								if (res_page.all_count > 0) {
									let t_list_data = res[1];
									// console.log(t_list_data);
									for (let i = 0; i < t_list_data.length; i++) {
										let arr = [];
										for (let j in t_list_data[i]) {
											let o = {};
											o.key = j;
											let temp_str = '';
											temp_str = t_list_data[i][j];
											if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") >
												0) {
												temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
												temp_str = ReplaceAll(temp_str, '\n', "<br/>");
												temp_str = temp_str.replace("\\r\\n", "\r\n");
												temp_str = temp_str.replace("\\n", "\n");
											}
											o.val = temp_str;
											arr.push(o);
										}
										bd.push(arr);
									}
								}

								this.sel_row(bd[0], 'edit');

							} else {
								this.$message({
									message: '编辑数据更新失败! \r\n ' + res.data.msg,
									type: 'success'
								});
							}

						});

					}



				}

				if (Number(page) > 0) {
					this.nowpage = page;
					this.load_db_data();
				}
				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			sel_row: function(item, type) {
				console.log(item);
				console.log('type=' + type);

				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}

				}

				switch (type) {
					case 'edit': // 切换背景色
						this.$refs.file_table.setCurrentRowJsonOld('m_', item[1].val);
						break;
					case 'show': // 打开编辑页面
						this.$refs.mypop.showpop();
						this.fun_d_load();
						break;
					default:
						break;
				}

			},
			fun_d_load: function() {
				this.list_detail = [];

				let d = [];
				d.push(this.sheet_no);

				this.element_loading = true;
				this.$post(
					api.http_method,
					Select_PageLengthMore('exp_cw_F2_fee_pass_d', 1, 999, d, 'tab')
				).then(res => {
					this.element_loading = false;

					res = JSON.parse(res);
					console.log('明细返回', res);
					if (res.length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.list_detail.push(t[i]);
						}
						console.log(this.list_detail);
					} else {
						this.$message({
							message: "没有查询到明细",
							type: 'success'
						});
					}
				});

			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			build_exceldata: function(type) {
				// 不做分页
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					let d=[];
					for (let i = 0; i < this.parm_sel.length; i++) {
						d.push(this.parm_sel[i].val)
					}
					// console.log(d);
					
					let that=this;

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Select_PageLengthMore(that.sel_action, that.nowpage, that.page_length, d, 'tab'
						)
					});

					this.show_excel = true;
				}
			},

			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_look_file: async function(item) {
				console.log('点击预览附件');
				if (typeof(item) !== 'undefined' && item != '') {
					await this.sel_row(item);
				}

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					var pdfview = document.getElementById('loodlink');
					pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					pdfview.click();

				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('savefile');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 5000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];

					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					this.file_size = size;

					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过5M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},

		}
	};
</script>


<style scoped>
	.td-image {
		cursor: pointer;
	}

	.pre-input {
		display: inline-block;
		vertical-align: middle;
		width: 128px;
	}
</style>
